import type { UserRegionalIdentity } from '../user.interface'

export function hasRegionalIdentityForRegion(identities: UserRegionalIdentity[], region: string): boolean {
  return identities.some((identity) => identity.region === region)
}
